import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-document-type-indicator',
  templateUrl: './document-type-indicator.component.html',
  styleUrls: ['./document-type-indicator.component.css'],
})
export class DocumentTypeIndicatorComponent implements OnInit {
  @Input() type: string;
  @Input() hidden: boolean = false;
  color: string;

  constructor() {}

  ngOnInit() {
    switch (this.type) {
      case 'invoice':
        this.color = 'primary';
        break;

      case 'credit-note':
        this.color = 'warning';
        break;

      case 'advance':
        this.color = 'success';
        break;

      case 'estimate':
        this.color = 'info';
        break;

      case 'delivery-note':
        this.color = 'secondary';
        break;

      default:
        this.color = 'default';
    }
  }
}
